import React, { FC } from 'react'

import styles from './ImagePlaceholder.module.scss'

export const ImagePlaceholder: FC = () => (
  <div className={styles.root}>
    <svg className={styles.icon} viewBox="0 0 70 60" xmlns="http://www.w3.org/2000/svg">
      <path d="M67.66.25H11.68a2.34 2.34 0 00-2.33 2.34v2.33H7a2.34 2.34 0 00-2.34 2.34V9.6H2.34A2.34 2.34 0 000 11.93v45.49a2.34 2.34 0 002.34 2.33h55.98a2.34 2.34 0 002.33-2.33v-2.34H63a2.34 2.34 0 002.34-2.34V50.4h2.33A2.34 2.34 0 0070 48.07V2.59c0-1.3-1.04-2.34-2.34-2.34zm-9.33 37.72l-6.11-7a1.17 1.17 0 00-1.76 0l-7.38 8.45-20.12-17.88c-.44-.4-1.1-.4-1.54 0L2.36 38.47V13.08c0-.64.52-1.16 1.17-1.16h53.64c.64 0 1.16.52 1.16 1.16v24.89zm3.51 14.76h-1.16V11.9a2.34 2.34 0 00-2.34-2.34H7.02V8.4c0-.65.52-1.16 1.17-1.16h53.64c.64 0 1.16.51 1.16 1.16L63 51.57c0 .64-.52 1.16-1.16 1.16zm4.66-4.68h-1.16V7.25A2.34 2.34 0 0063 4.9H11.68V3.75c0-.65.52-1.16 1.17-1.16h53.64c.64 0 1.16.51 1.16 1.16v43.14h.01c0 .64-.52 1.16-1.16 1.16z" />
      <path d="M42.01 18.9a4.67 4.67 0 10.01 9.33 4.67 4.67 0 000-9.33z" />
    </svg>
  </div>
)
